import { NavLink, useParams } from "react-router-dom";
import { routePaths } from "../constants/routes";
import { getOrderByInvoiceNumber } from "../services/orderService";
import "../style/orderSuccess.css";

export default function InvoicePage() {
  const { invoiceNumber } = useParams();
  const order = getOrderByInvoiceNumber(invoiceNumber);

  if (!order) {
    return (
      <div className="order-success-wrapper">
        <div className="order-success-card">
          <h1 className="success-title">Invoice not found</h1>
          <p className="success-subtitle">Place an order first or open invoice from order history.</p>
          <div className="success-actions">
            <NavLink to={routePaths.orderHistory} className="success-btn primary">
              Order History
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="order-success-wrapper">
      <div className="order-success-card">
        <div className="invoice-box invoice-header-box">
          <div>
            <p>Invoice Number</p>
            <strong>{order.invoiceNumber}</strong>
          </div>
          <div className="invoice-header-meta">
            <p>
              Order Date:{" "}
              <strong>
                {new Date(order.date).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </strong>
            </p>
            <p>
              Payment Method: <strong>{order.paymentMethod}</strong>
            </p>
            <p>
              Order Status: <strong>{order.status}</strong>
            </p>
          </div>
        </div>

        <div className="invoice-box order-items-box">
          <p><strong>Billing Summary</strong></p>
          <div className="success-item-row">
            <span>Subtotal</span>
            <strong>Rs.{order.subtotal.toLocaleString("en-IN")}</strong>
          </div>
          <div className="success-item-row">
            <span>Discount</span>
            <strong>- Rs.{order.discount.toLocaleString("en-IN")}</strong>
          </div>
          <div className="success-item-row">
            <span>Delivery</span>
            <strong>{order.delivery === 0 ? "FREE" : `Rs.${order.delivery.toLocaleString("en-IN")}`}</strong>
          </div>
          <div className="success-item-row">
            <span>Total Paid</span>
            <strong>Rs.{order.total.toLocaleString("en-IN")}</strong>
          </div>
        </div>

        <div className="invoice-box order-items-box">
          <p><strong>Purchased Items</strong></p>
          {order.items.map((item) => (
            <div key={item.id} className="success-item-row">
              <span>{item.name} x{item.quantity}</span>
              <strong>Rs.{(Number(item.price) * Number(item.quantity)).toLocaleString("en-IN")}</strong>
            </div>
          ))}
        </div>

        <div className="invoice-box">
          <p><strong>Shipping Address</strong></p>
          <p>{order.address.name}, {order.address.phone}</p>
          <p>{order.address.address1}{order.address.address2 ? `, ${order.address.address2}` : ""}</p>
          <p>{order.address.city}, {order.address.state} - {order.address.pincode}</p>
        </div>

        <div className="success-actions">
          <NavLink to={routePaths.orderTracking(order.invoiceNumber)} className="success-btn primary">
            Track Order
          </NavLink>
          <NavLink to={routePaths.orderHistory} className="success-btn secondary">
            Back to Orders
          </NavLink>
        </div>
      </div>
    </div>
  );
}
